import React from 'react';

function Terms(props) {
    return (
        <div className='main-info'>
        <section class="terms-of-use">
        <h2>Terms of Use</h2>

        <p>By accessing or using the Cryptocurrency Hub website or application ("service"), you agree to comply with and be bound by the following Terms of Use. If you do not agree with these terms, please do not use our service.</p>

        <h3>Use of the Service</h3>
        <p>You must be at least 18 years old to use this service. You agree to use the service for lawful purposes only and not to violate any applicable laws, regulations, or third-party rights.</p>

        <h3>Intellectual Property</h3>
        <p>All content and materials available on the service, including but not limited to text, graphics, logos, button icons, images, audio clips, and software, are the property of Cryptocurrency Hub and are protected by intellectual property laws.</p>

        <h3>Disclaimer of Warranties</h3>
        <p>The service is provided "as is" and "as available" without any warranties of any kind, whether express or implied. Cryptocurrency Hub does not warrant the accuracy, completeness, or reliability of any content or materials on the service.</p>

        <h3>Limitation of Liability</h3>
        <p>Cryptocurrency Hub and its affiliates, officers, employees, agents, partners, and licensors shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or use.</p>

        <h3>Termination</h3>
        <p>We reserve the right to terminate or suspend your access to the service at any time, without notice, for any reason, including violation of these Terms of Use.</p>

        <h3>Changes to Terms</h3>
        <p>We reserve the right to update or change these Terms of Use at any time. Any changes will be effective immediately upon posting the updated terms on this page.</p>

    </section>
        </div>
    );
}

export default Terms;